export default class NetworkError {
    constructor(
        public code: number,
        public message: string
    ) {}

    static isNetworError(a: any): a is NetworkError {
        return a instanceof NetworkError;
    }
}
